export default {
  getStockType: (state) => state.stockType,
};
